// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3tzdp","inner":"Footer_inner__2I9OV"};